export default "__VITE_ASSET__$CBu_cMq__"